export default __webpack_public_path__ + "4d1b9578966f3e9fc945ab2cbde0af12.mp3";